import { getApiClient, initializeApiClient } from "../../apiService";

export const AddTargetInfo = async (
  myPNatureOfTargetedGrouproperty,
  tG_TargetedGroupAgeId,
  expectedNumberOfBeneficiaries,
  additionalInformation,
  tG_mainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TargetedGroup/AddTG_TargetedGroup`,
    {
      myPNatureOfTargetedGrouproperty: myPNatureOfTargetedGrouproperty,
      tG_TargetedGroupAgeId: tG_TargetedGroupAgeId,
      expectedNumberOfBeneficiaries: expectedNumberOfBeneficiaries,
      additionalInformation: additionalInformation,
      tG_mainTargetedGroupId: tG_mainTargetedGroupId,
    }
  );

  return response;
};

export default AddTargetInfo;
